<script setup lang="ts" generic="T extends string">
import { TranslationParams } from "@voltalis/frontend-tooling/i18n/runtime";

import { useTypedIntl } from "@/locales/typed-intl";

export type IButtonGroupOption<T> = { value: T; label: TranslationParams };

interface IProps {
  options: IButtonGroupOption<T>[];
}

const props = defineProps<IProps>();

const selectedItem = defineModel<T>({
  required: true,
});

const { t } = useTypedIntl();
</script>

<template>
  <div class="h-[42px] border rounded-lg p-[6px] items-center flex gap-1">
    <button
      v-for="option in props.options"
      :key="option.value"
      class="px-4 rounded-lg h-full flex items-center justify-center w-[90px]"
      :class="{
        'bg-blue-100/50': selectedItem === option.value,
      }"
      @click="selectedItem = option.value"
    >
      <span :class="{ 'text-brand font-semibold': selectedItem === option.value }">{{ t(option.label) }}</span>
    </button>
  </div>
</template>

<style lang="scss"></style>
